import { getUnknownItemsRequest, deleteItemRequest } from '../requests';

function setValue({ commit }, { value, key }) {
	commit('setValue', { value, key });
}

async function getItems({ commit, state }) {
	commit('set', (state) => { state.loading = true; });
	try {
		let items = await getUnknownItemsRequest();
		commit('set', () => { state.items = items; });
	} catch (err) {
		throw new Error('failedToFetch');
	}
	commit('set', (state) => { state.loading = false; });
}

function setModalUrl({ commit, state }, url) {
	commit('set', () => { state.modalUrl = url; });
}

async function deleteItems({ state, commit }, itemsToDelete) {
	let storedItems = state.items;
	let idsToRemove = [];
	for (let dItem of itemsToDelete) {
		idsToRemove.push(dItem.id);
	}
	try {
		for (let itemId of idsToRemove) {
			await deleteItemRequest(itemId);
		}
		let updatedItems = storedItems.filter(item => idsToRemove.indexOf(item.id) < 0);
		commit('set', () => { state.items = updatedItems; });
	} catch (err) {
		throw new Error('failedToDelete');
	}
}

export default {
	setValue,
	getItems,
	setModalUrl,
	deleteItems,
};
